<template>
  <div class="dialog-wrap">
    <div class="dialog-bg" @click="onBackGroundClick"></div>
    <div class="dialog-wrap-content">
      <div class="dialog-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";


@Options({ 
  components: {  },
  emits: ['click-background'],
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;

  onBackGroundClick(event:any){
    this.$emit("click-background", event)
  }
}
</script>

<style lang="scss" scoped>
.dialog-wrap {
  z-index: 1000; /*<b-form-file>コンポーネントにz-index=2が設定されているため、それ以上に値を設定する。 */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.dialog-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.7;
  background-color: #000;
}

.dialog-wrap-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  margin: auto;
  pointer-events: none;
}
.dialog-content {
  position: relative;
  pointer-events: auto;
  text-align: left;
  display: inline-block;
  background-color: #fff;
  opacity: 1;
  border-radius: 10px;
}
</style>